'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { DropdownMenu, DropdownMenuItem } from '@repo/design-system/components/ui/dropdown-menu';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { useCurrentLanguage } from '@repo/i18n/hooks/use-current-language';
import { type LanguageCode, languageMap } from '@repo/i18n/i18n-resources/languages';
import { css } from '@repo/panda/css';
import { useEffect, useState } from 'react';
import { getLocalizedCurrentPath } from '../utils/localized-current-path';
export const LanguageSelector = () => {
  const $ = _c(15);
  const currentLanguage = useCurrentLanguage();
  const [isHovered, setIsHovered] = useState(false);
  const [mounted, setMounted] = useState(false);
  const {
    t
  } = useT("game_map");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    return null;
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsHovered(true);
    t3 = () => setIsHovered(false);
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon icon="language" decorative={true} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isHovered || $[6] !== t) {
    t5 = isHovered && <span>{t(_temp)}</span>;
    $[5] = isHovered;
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Button variant="ghost" color="primary" size="md" title="Change language">{t4}{t5}</Button>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== currentLanguage) {
    t7 = Object.entries(languageMap).map(t8 => {
      const [langCode, langInfo] = t8;
      return <DropdownMenuItem key={langCode} value={langCode} asChild={true}><a onKeyDown={e => {
          if (e.key === "Enter") {
            if (currentLanguage === langCode) {
              return;
            }
            const path = getLocalizedCurrentPath(langCode as LanguageCode, currentLanguage);
            if (path) {
              window.location.href = path;
            }
          }
        }} href={getLocalizedCurrentPath(langCode as LanguageCode, currentLanguage)} className={css({
          pointerEvents: currentLanguage === langCode ? "none" : "auto",
          textDecoration: "none",
          display: "flex",
          padding: "8",
          flexDirection: "row",
          gap: "8",
          alignItems: "center",
          borderRadius: "6",
          "&:hover": {
            backgroundColor: "whiteAlpha.10"
          },
          "&:focus-visible": {
            backgroundColor: "whiteAlpha.10"
          }
        })}>{currentLanguage === langCode && <Icon className={css({
            marginRight: "4"
          })} icon="check" size="sm" decorative={true} />}<div className={css({
            display: "flex",
            flexDirection: "column"
          })}><Type variant="header-s" as="span"><span>{langInfo.native}</span></Type><Type variant="caption" color="text.secondary" as="span">{langInfo.name}</Type></div></a></DropdownMenuItem>;
    });
    $[10] = currentLanguage;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div onMouseEnter={t2} onMouseLeave={t3}><DropdownMenu size="sm" variant="dark" placement="bottom-end" trigger={t6}>{t7}</DropdownMenu></div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function _temp($) {
  return $.language;
}